import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { getSubscriptionFlowApiClient } from "@shared/apis/sidekick/api-factories";
import { GetSubscriptionFlowStateResponse } from "@shared/apis/sidekick/generated";
import {
  ApiError,
  apiResponseErrorHandler,
} from "@shared/apis/sidekick/api-error-handler";

export const GET_SUBSCRIPTION_FLOW_QUERY_KEY = "subscription-flow";

type Props = {
  onSuccess?: (data: GetSubscriptionFlowStateResponse) => void;
  onError?: (error: ApiError) => void;
  id: string;
  token?: string;
};

export const useGetSubscriptionFlow = (props: Props) => {
  const { id, token } = props || {};
  const api = getSubscriptionFlowApiClient();
  const query = useQuery({
    queryKey: [GET_SUBSCRIPTION_FLOW_QUERY_KEY, { id, token }],
    queryFn: async () => {
      try {
        const data =
          await api.subscriptionFlowControllerGetSubscriptionFlowState({
            id,
            token,
          });
        props?.onSuccess?.(data);
        return data;
      } catch (e) {
        console.error(
          `Error trying to fetch the subscription with id ${id}`,
          e
        );
        const error = await apiResponseErrorHandler(e);
        props?.onError?.(error);
        throw error;
      }
    },
    enabled: !!id,
    refetchOnWindowFocus: false,
  });

  return extractQueryState(query);
};
